// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"769df672","453":"0c4585f1"}[chunkId] + ".chunk.js";
};